// Constants
import { HANDLER_RETURN_VALUES } from '../../draftjsConstants';

export default (editorState, newEditorState, { setEditorState }) => {
    if (editorState !== newEditorState) {
        setEditorState(newEditorState);
        return HANDLER_RETURN_VALUES.handled;
    }

    return HANDLER_RETURN_VALUES.notHandled;
};
